@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">District Of Columbia</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <!-- Taxi cab Radio buttons -->
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <!-- UMBI & UMPD Radio Group level two -->
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <!-- UMBI & UMPD Radio Group level three -->
      @if (controls?.length > 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[2].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[2].formControlName)?.touched &&
              reactiveForm.get(controls[2].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
            @for (control of controls[2].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[2].formControlName)?.touched) {
            @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <!-- UMBI Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 4 : 10; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                  (onSelect)="onSelect(baseRules['selectionId'], control.formControlName)"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the {{ control.label }}.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>

      <!-- UIM Radio group level one -->
      @if (controls?.length >= 3) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[3].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[3].formControlName)?.touched &&
              reactiveForm.get(controls[3].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[3].formControlName }}">
            @for (control of controls[3].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[3].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[3].formControlName)?.touched) {
            @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <!-- UIM Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 10 : 12; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the {{ control.label }}.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>
      <!-- Read the current Level-One (Taxicabs / No Taxicabs) selection -->
      @let L1_CTRL = controls[0].formControlName;
      @let l1Val = reactiveForm?.get(L1_CTRL)?.value;
      @let l1Key = (l1Val?.select ?? l1Val?.value ?? l1Val) || "";
      <!-- Taxicabs-->
      @if (l1Key === "Taxicabs_LevelOne_Radio") {
        <!-- Show your read-only reject texts driven by baseRules -->
        @if ((baseRules?.["Reject_LevelTwo_Radio"] || "").includes("Yes")) {
          <div class="axis-grid">
            <div class="axis-col-sm-6 axis-col-md-4">
              <div class="axis-form-group">
                <label
                  class="axis-control-label"
                  id="reject_leveltwo_radio-pdffield-district-of-columbia"
                  >{{ textValues?.Reject_Text }}</label
                >
              </div>
            </div>
          </div>
        }

        @if ((baseRules?.["Reject_LevelThree_Radio"] || "").includes("Yes")) {
          <div class="axis-grid">
            <div class="axis-col-sm-6 axis-col-md-4">
              <div class="axis-form-group">
                <label
                  class="axis-control-label"
                  id="reject_levelthree_radio-pdffield-district-of-columbia"
                  >{{ textValues?.Reject_Text_UIM }}</label
                >
              </div>
            </div>
          </div>
        }
      }

      <div class="axis-grid">
        @if ((baseRules?.["UMBI_UMPD_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[10].label }}</label>
              <div id="umbi_umpd_combinedsingleminlimit_55k-pdffield-district-of-columbia">
                {{ controls[10].data[0].name }}
              </div>
            </div>
          </div>
        }

        @if ((baseRules?.["UMBI_SplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[6].label }}</label>
              <div id="umbi_splitminlimits_25k_50k-pdffield-district-of-columbia">
                {{ controls[6].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UMBI_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[7].label }}</label>
              <div id="umbi_combinedsingleminlimit_5k-pdffield-district-of-columbia">
                {{ controls[7].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UMPD_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[9].label }}</label>
              <div id="umpd_combinedsingleminlimit_5k-pdffield-district-of-columbia">
                {{ controls[9].data[0].name }}
              </div>
            </div>
          </div>
        }
      </div>

      <!-- No Taxicabs -->
      @if (l1Key === "NoTaxicabs_LevelOne_Radio") {
        <!--read-only UIM reject text -->
        @if ((baseRules?.["Reject_LevelThree_Radio"] || "").includes("Yes")) {
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              id="reject_levelthree_radio-pdffield-district-of-columbia"
              >{{ textValues?.Reject_Text_UIM }}</label
            >
          </div>
        }
      }

      @if ((baseRules?.["Select_LevelThree_Radio"] || "").includes("Yes")) {
        <div class="axis-form-group">
          <label
            class="axis-control-label"
            id="select_levelthree_radio-pdffield-district-of-columbia"
          >
            {{ textValues?.Select_Text_UIM }}
          </label>
        </div>
      }
    </form>
    <p>{{ textValues?.description }}</p>
  }
}

<!-- Review Section -->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">District Of Columbia</h2>

  <!-- DROPDOWN VALUES -->
  <div class="axis-grid">
    @for (control of controls | slice: 4 : 12; track $index) {
      @if (baseRules[control.baseRuleKey]) {
        <div class="axis-col-sm-6 axis-col-lg-6">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ control.label }}</label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>
  <!-- Reject texts -->
  @if (baseRules?.Reject_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text }}
      </label>
      <div>{{ baseRules?.Reject_LevelOne_Radio }}</div>
    </div>
  }

  @if (baseRules?.Reject_LevelTwo_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text }}
      </label>
      <div>{{ baseRules?.Reject_LevelTwo_Radio }}</div>
    </div>
  }
  <!--UMPD Reject text-->
  @if (baseRules?.Reject_LevelThree_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text_UIM }}
      </label>
    </div>
  }

  @if (baseRules?.Select_LevelThree_Radio || baseRules?.LiabilityLimit_DropDown) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Select_Text_UIM }}
      </label>
    </div>
  }
}
